import React from 'react';

/**
 * Pega o erro de tela que derrubaria o aplicativo inteiro.
 *
 * Sem isto, qualquer erro durante a renderizacao desmonta tudo e a pessoa fica
 * olhando uma pagina em branco, sem saber se o que fez foi salvo nem o que
 * fazer. Foi o que aconteceu com um motorista no meio do checklist, em
 * 28/10/2026: a tela sumiu logo depois da primeira foto.
 *
 * Precisa ser classe: o React so oferece captura de erro de renderizacao por
 * `componentDidCatch`/`getDerivedStateFromError`.
 */
interface Estado {
  erro: Error | null;
}

class ProtecaoDeErro extends React.Component<{ children: React.ReactNode }, Estado> {
  state: Estado = { erro: null };

  static getDerivedStateFromError(erro: Error): Estado {
    return { erro };
  }

  componentDidCatch(erro: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[Erro de tela]', erro, info.componentStack);
  }

  render() {
    if (!this.state.erro) return this.props.children;

    return (
      <div role="alert" className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="max-w-sm w-full bg-white rounded-xl border border-gray-200 p-6 text-center shadow-sm">
          <h1 className="text-lg font-semibold text-gray-900">Algo deu errado nesta tela</h1>
          <p className="mt-2 text-sm text-gray-600">
            O que você já enviou está salvo. O que ainda não foi enviado precisa ser preenchido de novo.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-5 w-full rounded-lg bg-blue-600 py-3 font-semibold text-white hover:bg-blue-700"
          >
            Recarregar
          </button>
          <p className="mt-3 text-xs text-gray-400">Se acontecer de novo, avise o gestor.</p>
        </div>
      </div>
    );
  }
}

export default ProtecaoDeErro;
